var map = {
	"./datepicker.cs": 1,
	"./datepicker.cs.js": 1,
	"./datepicker.da": 2,
	"./datepicker.da.js": 2,
	"./datepicker.de": 3,
	"./datepicker.de.js": 3,
	"./datepicker.en": 4,
	"./datepicker.en.js": 4,
	"./datepicker.es": 5,
	"./datepicker.es.js": 5,
	"./datepicker.fi": 6,
	"./datepicker.fi.js": 6,
	"./datepicker.fr": 7,
	"./datepicker.fr.js": 7,
	"./datepicker.hu": 8,
	"./datepicker.hu.js": 8,
	"./datepicker.nl": 9,
	"./datepicker.nl.js": 9,
	"./datepicker.pl": 10,
	"./datepicker.pl.js": 10,
	"./datepicker.pt": 11,
	"./datepicker.pt-BR": 12,
	"./datepicker.pt-BR.js": 12,
	"./datepicker.pt.js": 11,
	"./datepicker.ro": 13,
	"./datepicker.ro.js": 13,
	"./datepicker.sk": 14,
	"./datepicker.sk.js": 14,
	"./datepicker.zh": 15,
	"./datepicker.zh.js": 15
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 0;


//////////////////
// WEBPACK FOOTER
// ./node_modules/air-datepicker/dist/js/i18n ^\.\/datepicker\..*$
// module id = 0
// module chunks = 0